import React from 'react'
import wert from "../Assets/images/wert.jpg"
import "../Assets/styles/project.css"
import { GrProjects } from "react-icons/gr";

const Projects = () => {
  return (
    <>
      <div className="anon">
      <div className='anon-bg'>
      <h1><GrProjects/></h1>
      <h4><a href='/home'>Home </a><span className='dot'></span> Contact</h4>
      </div>
    </div>
      <div className='container yeye'>
        <div className='row'>
          <div className='col-md-6 wet'>
            <img src={wert} alt='wert'/>
          </div>
          <div className='col-md-6 wet'>
            <img src={wert} alt='wert'/>
          </div>
        </div>
      </div>
      <div className='container tekken'>
        <h3>Competitor Analysis</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        <h4><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/000000/checkmark--v1.png" alt="checkmark--v1"/> Core Development</h4>
        <p>No fake products and services. The customer is king, their lives and needs are the inspiration. But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.</p>
        <h4><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/000000/checkmark--v1.png" alt="checkmark--v1"/> Define Your Choices</h4>
        <p>
        No fake products and services. The customer is king, their lives and needs are the inspiration. At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.
        Nost rud no eos, no impedit dissenti as mea, ea vide labor amus neglegentur vix. Ancillae intellegat vix et. Sit causae laoreet nolu ise. Ad po exerci nusquam eos te. Cu altera expet enda qui, munere oblique theo phrastu ea vix. Ne nec modus civibus modera tius, sit ei lorem doctus. Ne docen di verterem reformidans eos. Cu altera expetenda qui, munere oblique theophr astus ea vix modus civiu mod eratius.
        </p>
      </div>
    </>
  )
}

export default Projects